import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import styles from "./styles.module.scss";
import { setFilteredArchive } from "../../../../../redux/filter/filteredArchiveSlice";

const FilterByDate = ({ title, field, prefix }) => {
  const [selectedValues, setSelectedValues] = useState({
    from: "",
    to: new Date().toISOString().split("T")[0],
  });
  const dispatch = useDispatch();
  const transcripts = useSelector(
    (state) => state.filteredArchiveSlice.transcripts
  );
  const originalTranscriptsRef = useRef();

  if (!originalTranscriptsRef.current && transcripts.length > 0) {
    originalTranscriptsRef.current = transcripts;
  }

  const handleFromChange = (value) => {
    setSelectedValues((prevValues) => ({ ...prevValues, from: value }));
  };
  const handleToChange = (value) => {
    setSelectedValues((prevValues) => ({ ...prevValues, to: value }));
  };

  useEffect(() => {
    if (
      !originalTranscriptsRef.current ||
      !selectedValues.from ||
      !selectedValues.to
    )
      return;
    const filteredTranscripts = originalTranscriptsRef.current.filter(
      (transcript) => {
        const transcriptDate = new Date(transcript[field]);
        const fromDate = new Date(selectedValues.from);
        const toDate = new Date(selectedValues.to);
        return transcriptDate >= fromDate && transcriptDate <= toDate;
      }
    );
    dispatch(setFilteredArchive(filteredTranscripts));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValues]);


  return (
    <fieldset className={styles.fieldset}>
      <legend>{title}</legend>
      <div className={styles.container}>
        <div className={styles.wrapper}>
        <label htmlFor={`${prefix}-from`}>From:</label>
        <input
          type="date"
          id={`${prefix}-from`}
          name={`${prefix}-from`}
          value={selectedValues.from}
          onChange={(e) => handleFromChange(e.target.value)}
          max={selectedValues.to}
        />
        </div>
        <div className={styles.wrapper}>
        <label htmlFor={`${prefix}-to`}>To:</label>
        <input
          type="date"
          id={`${prefix}-to`}
          name={`${prefix}-to`}
          value={selectedValues.to}
          onChange={(e) => handleToChange(e.target.value)}
          min={selectedValues.from}
          max={new Date().toISOString().split("T")[0]}
        />
        </div>
      </div>
      {selectedValues.from && selectedValues.to && (
      <div className={styles.cta}>
        <button
          onClick={() => {
            setSelectedValues({ from: "", to: new Date().toISOString().split("T")[0] });
            dispatch(setFilteredArchive(originalTranscriptsRef.current));
          }}
        >
          Clear
        </button>
      </div>
      )}
    </fieldset>
  );
};

export default FilterByDate;
